<!-- 系统授权 -->
<template>
    <div>
        <div class="header">
            <Input
                class="w200 mr24 mb24"
                type="text"
                v-model="storePrams.keywords"
                placeholder="请输入关键词"
            ></Input>
            <Button
                class="theme-bc mb24"
                icon="ios-search"
                type="warning"
                @click="goSearch"
                >确认搜索</Button
            >
        </div>
        <div class="content">
            <Button
                class="theme-bc mb24"
                icon="md-add-circle"
                type="warning"
                @click="gomodal"
                >新增账号</Button
            >
            <Table :columns="columnsTable" :data="dataTable" border>
                <template slot-scope="{ row }" slot="is_auth">
                    <i-switch
                        v-model="row.is_auth"
                        size="large"
                        true-color="#FF761D"
                        :true-value="1"
                        :false-value="0"
                        @on-change="changeMouldOperate(row, $event)"
                    >
                        <span slot="open">开启</span>
                        <span slot="close">关闭</span>
                    </i-switch>
                </template>
                <template slot-scope="{ row }" slot="operate">
                    <div class="flex-sa">
                        <Button
                            type="primary"
                            ghost
                            label="small"
                            @click="gomodal(row)"
                            >编辑</Button
                        >
                        <Button
                            type="error"
                            ghost
                            label="small"
                            @click="goDel(row)"
                            >删除</Button
                        >
                    </div>
                </template>
            </Table>
            <div class="text-align-right mt24">
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>
        <!-- 新增/编辑 -->
        <Modal
            v-model="modals"
            :title="modalTitle"
            width="500"
            :mask-closable="false"
        >
            <Form :model="formItem" label-position="right" :label-width="100">
                <FormItem label="公司名称：">
                    <Input
                        class="w200"
                        type="text"
                        v-model="formItem.company"
                        placeholder="请输入公司名称"
                    ></Input>
                </FormItem>
                <FormItem label="手机号：">
                    <Input
                        class="w200"
                        type="number"
                        v-model="formItem.phone"
                        placeholder="请输入手机号"
                    ></Input>
                </FormItem>
                <FormItem label="IP：">
                    <Input
                        class="w200"
                        type="text"
                        v-model="formItem.ip"
                        placeholder="请输入IP"
                    ></Input>
                </FormItem>
                <FormItem label="域名：">
                    <Input
                        class="w200"
                        type="text"
                        v-model="formItem.domain"
                        placeholder="请输入域名"
                    ></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button class="theme-bc" type="warning" @click="submitModal"
                    >确认</Button
                >
            </div>
        </Modal>
    </div>
</template>

<script>
import { auth_index, auth_save, auth_change, auth_delete } from "@/api/index";
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 30,
                keywords: "",
            },
            total: 0,
            columnsTable: [
                { title: "账号ID", key: "id", align: "center" },
                { title: "公司名称", key: "company", align: "center" },
                { title: "手机号", key: "phone", align: "center" },
                { title: "IP", key: "ip", align: "center" },
                { title: "域名", key: "domain", align: "center" },
                { title: "是否授权", slot: "is_auth", align: "center" },
                { title: "创建时间", key: "created_at", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],
            dataTable: [],
            modals: false,
            modalTitle: "",
            formItem: {
                company: "",
                phone: "",
                ip: "",
                domain: "",
                id: "",
            },
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            auth_index(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        goSearch() {
            this.storePrams.page = 1;
            this.getList();
        },
        gomodal(row) {
            if (row.id) {
                this.modalTitle = "编辑账号";
                this.formItem.id = row.id;
                this.formItem.company = row.company;
                this.formItem.phone = row.phone;
                this.formItem.ip = row.ip;
                this.formItem.domain = row.domain;
            } else {
                this.modalTitle = "新增账号";
                this.formItem.id = "";
                this.formItem.company = "";
                this.formItem.phone = "";
                this.formItem.ip = "";
                this.formItem.domain = "";
            }
            this.modals = true;
        },
        // 确定
        submitModal() {
            auth_save(this.formItem)
                .then((res) => {
                    this.getList();
                    this.modals = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        cancelModal() {
            this.modals = false;
        },
        goDel(row) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？",
                onOk: () => {
                    auth_delete({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        changeMouldOperate(row, e) {
            let data = {
                id: row.id,
                status: e,
            };
            this.$Modal.confirm({
                title: "修改提示",
                content: "确认修改授权状态吗？",
                onOk: () => {
                    auth_change(data)
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {
                    this.getList();
                },
            });
        },
    },
};
</script>

<style scoped>
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.text-align-right {
    text-align: right;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>